export default __webpack_public_path__ + "static/media/product-7-min.3a58833c.jpg";